import { katTranslator } from '../../shared/i18n';

const strings = {
  kat_upload_file: {
    'en-US': 'Upload file',
    'fr-FR': 'Charger le fichier',
    'fr-CA': 'Téléverser un fichier',
    'ja-JP': 'ファイルをアップロードします',
    'es-ES': 'Cargar archivo',
    'es-MX': 'Cargar archivo',
    'es-US': 'Cargar archivo',
    'pt-PT': 'Carregar ficheiro',
    'zh-TW': '上傳檔案',
    'tr-TR': 'Dosya yükle',
    'de-DE': 'Datei hochladen',
    'nl-NL': 'Bestand uploaden',
    'pl-PL': 'Prześlij plik',
    'ta-IN': 'கோப்பைப் பதிவேற்று',
    'mr-IN': 'फाईल अपलोड करा',
    'ml-IN': 'ഫയൽ അപ്‌ലോഡ് ചെയ്യുക',
    'te-IN': 'ఫైల్‍‌ను అప్‌లోడ్ చేయండి',
    'kn-IN': 'ಫೈಲ್ ಅನ್ನು ಅಪ್‌ಲೋಡ್‌ ಮಾಡಿ',
    'sv-SE': 'Ladda upp fil',
    'cs-CZ': 'Nahrát soubor',
    'it-IT': 'Carica file',
    'pt-BR': 'Fazer upload do arquivo',
    'zh-CN': '上传文件',
    'ko-KR': '파일 업로드',
    'ar-AE': 'تحميل ملف',
    'hi-IN': 'फ़ाइल अपलोड करें',
    'bn-IN': 'ফাইল আপলোড করুন',
    'he-IL': 'העלאת קובץ',
  },
  kat_upload_files: {
    'en-US': 'Upload files',
    'fr-FR': 'Charger les fichiers',
    'fr-CA': 'Téléverser des fichiers',
    'ja-JP': 'ファイルをアップロード',
    'es-ES': 'Cargar archivos',
    'es-MX': 'Cargar archivos',
    'es-US': 'Cargar archivos',
    'pt-PT': 'Carregar ficheiros',
    'zh-TW': '上傳檔案',
    'tr-TR': 'Dosyaları yükle',
    'de-DE': 'Dateien hochladen',
    'nl-NL': 'Bestanden uploaden',
    'pl-PL': 'Prześlij pliki',
    'ta-IN': 'கோப்புகளைப் பதிவேற்று',
    'mr-IN': 'फाईल्स अपलोड करा',
    'ml-IN': 'ഫയലുകൾ അപ്‌ലോഡ് ചെയ്യുക',
    'te-IN': 'ఫైళ్లను అప్‌లోడ్ చేయండి',
    'kn-IN': 'ಫೈಲ್‌ಗಳನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಿ',
    'sv-SE': 'Ladda upp filer',
    'cs-CZ': 'Nahrát soubory',
    'it-IT': 'Carica file',
    'pt-BR': 'Fazer upload dos arquivos',
    'zh-CN': '上传文件',
    'ko-KR': '파일 업로드',
    'ar-AE': 'تحميل ملفات',
    'hi-IN': 'फ़ाइलें अपलोड करें',
    'bn-IN': 'ফাইল আপলোড করুন',
    'he-IL': 'העלאת קבצים',
  },
  kat_select_file: {
    'en-US': 'Select file',
    'fr-FR': 'Sélectionner un fichier',
    'fr-CA': 'Sélectionner le fichier',
    'ja-JP': 'ファイルを選択',
    'es-ES': 'Seleccionar archivo',
    'es-MX': 'Seleccionar archivo',
    'es-US': 'Seleccionar archivo',
    'pt-PT': 'Selecionar ficheiro',
    'zh-TW': '選擇檔案',
    'tr-TR': 'Dosya seç',
    'de-DE': 'Datei auswählen',
    'nl-NL': 'Bestand selecteren',
    'pl-PL': 'Wybierz plik',
    'ta-IN': 'கோப்பைத் தேர்ந்தெடு',
    'mr-IN': 'फाईल निवडा',
    'ml-IN': 'ഫയൽ തിരഞ്ഞെടുക്കുക',
    'te-IN': 'ఫైల్‌ను ఎంచుకోండి',
    'kn-IN': 'ಫೈಲ್ ಆಯ್ಕೆಮಾಡಿ',
    'sv-SE': 'Välj fil',
    'cs-CZ': 'Vybrat soubor',
    'it-IT': 'Seleziona file',
    'pt-BR': 'Selecionar arquivo',
    'zh-CN': '选择文件',
    'ko-KR': '파일 선택',
    'ar-AE': 'تحديد ملف',
    'hi-IN': 'फ़ाइल चुनें',
    'bn-IN': 'ফাইল নির্বাচন করুন',
    'he-IL': 'בחירת קובץ',
  },
  kat_select_files: {
    'en-US': 'Select files',
    'fr-FR': 'Sélectionner les fichiers',
    'fr-CA': 'Sélectionner les fichiers',
    'ja-JP': 'ファイルを選択',
    'es-ES': 'Seleccionar archivos',
    'es-MX': 'Seleccionar archivos',
    'es-US': 'Seleccionar archivos',
    'pt-PT': 'Selecionar ficheiros',
    'zh-TW': '選擇檔案',
    'tr-TR': 'Dosyaları seç',
    'de-DE': 'Dateien auswählen',
    'nl-NL': 'Selecteer bestanden',
    'pl-PL': 'Wybierz pliki',
    'ta-IN': 'கோப்புகளைத் தேர்ந்தெடு',
    'mr-IN': 'फाईल्स निवडा',
    'ml-IN': 'ഫയലുകൾ തിരഞ്ഞെടുക്കുക',
    'te-IN': 'ఫైళ్ళను ఎంచుకోండి',
    'kn-IN': 'ಫೈಲ್‌ಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    'sv-SE': 'Välj filer',
    'cs-CZ': 'Vybrat soubory',
    'it-IT': 'Seleziona file',
    'pt-BR': 'Selecionar arquivos',
    'zh-CN': '选择文件',
    'ko-KR': '파일 선택',
    'ar-AE': 'تحديد ملفات',
    'hi-IN': 'फ़ाइलें चुनें',
    'bn-IN': 'ফাইলগুলি নির্বাচন করুন',
    'he-IL': 'יש לבחור קבצים',
  },
  kat_drag_file_here_to_attach: {
    'en-US': 'Drag file here to attach',
    'fr-FR': 'Faites glisser le fichier ici pour le joindre',
    'fr-CA': 'Faites glisser le fichier ici pour le joindre',
    'ja-JP': 'ファイルをここにドラッグして添付',
    'es-ES': 'Arrastra el archivo aquí para adjuntarlo',
    'es-MX': 'Arrastra aquí el archivo para adjuntarlo',
    'es-US': 'Arrastra el archivo aquí para adjuntarlo',
    'pt-PT': 'Arraste o ficheiro que pretende anexar para aqui',
    'zh-TW': '將檔案拖到此處以附加',
    'tr-TR': 'Eklemek için dosyayı buraya sürükleyin',
    'de-DE': 'Datei zum Anhängen hierher ziehen',
    'nl-NL': 'Sleep het bestand hierheen om bij te voegen',
    'pl-PL': 'Przeciągnij plik tutaj, aby dołączyć',
    'ta-IN': 'இணைக்க, கோப்பினை இங்கு இழுக்கவும்',
    'mr-IN': 'अ‍ॅटॅच करण्यासाठी फाईल येथे ड्रॅग करा',
    'ml-IN': 'അറ്റാച്ചുചെയ്യുന്നതിന് ഫയൽ ഇവിടെ വലിച്ചിടുക',
    'te-IN': 'జోడించేందుకై ఫైల్‌ను ఇక్కడకు లాగండి',
    'kn-IN': 'ಲಗತ್ತಿಸಲು ಫೈಲ್ ಅನ್ನು ಇಲ್ಲಿ ಎಳೆಯಿರಿ',
    'sv-SE': 'Dra filen hit för att bifoga',
    'cs-CZ': 'Pro připojení přetáhněte soubor sem',
    'it-IT': 'Trascina qui il file per allegarlo',
    'pt-BR': 'Arraste o arquivo aqui para anexar',
    'zh-CN': '将文件拖到此处进行附加',
    'ko-KR': '첨부할 파일을 여기로 드래그하세요.',
    'ar-AE': 'اسحب الملف هنا لإرفاقه',
    'hi-IN': 'अटैच करने के लिए फ़ाइल को यहां ड्रैग करें',
    'bn-IN': 'সংযুক্ত করতে এখানে ফাইল টেনে আনুন',
    'he-IL': 'יש לגרור קובץ לכאן כדי לצרף',
  },
  kat_drag_files_here_to_attach: {
    'en-US': 'Drag files here to attach',
    'fr-FR': 'Faites glisser les fichiers ici pour les joindre',
    'fr-CA': 'Faites glisser les fichiers ici pour les joindre',
    'ja-JP': 'ファイルをここにドラッグして添付',
    'es-ES': 'Arrastra archivos aquí para adjuntarlos',
    'es-MX': 'Arrastra aquí los archivos para adjuntarlos',
    'es-US': 'Arrastra los archivos aquí para adjuntarlos',
    'pt-PT': 'Arraste os ficheiros que pretende anexar para aqui',
    'zh-TW': '將檔案拖到此處以附加',
    'tr-TR': 'Eklemek için dosyaları buraya sürükleyin',
    'de-DE': 'Ziehen Sie die Dateien zum Anhängen hierher',
    'nl-NL': 'Sleep bestanden hierheen om bij te voegen',
    'pl-PL': 'Przeciągnij pliki tutaj, aby dołączyć',
    'ta-IN': 'இணைக்க இங்கே கோப்புகளை இழுக்கவும்',
    'mr-IN': 'अ‍ॅटॅच करण्यासाठी फाईल्स येथे ड्रॅग करा',
    'ml-IN': 'അറ്റാച്ചുചെയ്യുന്നതിന് ഫയലുകൾ ഇവിടെ വലിച്ചിടുക',
    'te-IN': 'జోడించేందుకై ఫైళ్లను ఇక్కడకు లాగండి',
    'kn-IN': 'ಲಗತ್ತಿಸಲು ಫೈಲ್‌ಗಳನ್ನು ಇಲ್ಲಿ ಎಳೆಯಿರಿ',
    'sv-SE': 'Dra filer hit för att bifoga',
    'cs-CZ': 'Pro připojení přetáhněte soubory sem',
    'it-IT': 'Trascina qui i file per allegarli',
    'pt-BR': 'Arraste os arquivos aqui para anexar',
    'zh-CN': '将文件拖到此处进行附加',
    'ko-KR': '첨부할 파일을 여기로 드래그하세요.',
    'ar-AE': 'اسحب الملفات هنا لإرفاقها',
    'hi-IN': 'अटैच करने के लिए फ़ाइलों को यहां ड्रैग करें',
    'bn-IN': 'সংযুক্ত করতে এখানে ফাইল টেনে আনুন',
    'he-IL': 'יש לגרור קבצים לכאן כדי לצרף',
  },
  kat_drag_file_here_to_upload: {
    'en-US': 'Drag file here to upload',
    'fr-FR': 'Faites glisser le fichier ici pour le télécharger',
    'fr-CA': 'Faites glisser le fichier ici pour le téléverser',
    'ja-JP': 'ファイルをここにドラッグしてアップロード',
    'es-ES': 'Arrastra el archivo aquí para subirlo',
    'es-MX': 'Arrastra aquí el archivo para subirlo',
    'es-US': 'Arrastra el archivo aquí para cargarlo',
    'pt-PT': 'Arraste o ficheiro que pretende carregar para aqui',
    'zh-TW': '將檔案拖到此處以上傳',
    'tr-TR': 'Yüklemek için dosyayı buraya sürükleyin',
    'de-DE': 'Datei zum Hochladen hierher ziehen',
    'nl-NL': 'Sleep het bestand hierheen om te uploaden',
    'pl-PL': 'Przeciągnij plik tutaj, aby przesłać',
    'ta-IN': 'பதிவேற்ற கோப்பை இங்கே இழுக்கவும்',
    'mr-IN': 'अपलोड करण्यासाठी फाईल येथे ड्रॅग करा',
    'ml-IN': 'അപ്‌ലോഡ് ചെയ്യുന്നതിന് ഫയൽ ഇവിടെ വലിച്ചിടുക',
    'te-IN': 'అప్‌లోడ్ చేసేందుకై ఫైల్‌ను ఇక్కడకు లాగండి',
    'kn-IN': 'ಅಪ್‌ಲೋಡ್ ಮಾಡಲು ಫೈಲ್ ಅನ್ನು ಇಲ್ಲಿ ಎಳೆಯಿರಿ',
    'sv-SE': 'Dra filen hit för att ladda upp',
    'cs-CZ': 'Pro nahrání přetáhněte soubor sem',
    'it-IT': 'Trascina qui il file per caricarlo',
    'pt-BR': 'Arraste o arquivo aqui para fazer upload',
    'zh-CN': '将文件拖到此处进行上传',
    'ko-KR': '업로드할 파일을 여기로 드래그하세요.',
    'ar-AE': 'اسحب الملف هنا لتحميله',
    'hi-IN': 'अपलोड करने के लिए फ़ाइल को यहां ड्रैग करें',
    'bn-IN': 'আপলোড করার জন্য এখানে ফাইল টেনে আনুন',
    'he-IL': 'יש לגרור קובץ לכאן כדי להעלות',
  },
  kat_drag_files_here_to_upload: {
    'en-US': 'Drag files here to upload',
    'fr-FR': 'Faites glisser les fichiers ici pour les charger',
    'fr-CA': 'Faites glisser les fichiers ici pour téléverser',
    'ja-JP': 'ファイルをここにドラッグしてアップロード',
    'es-ES': 'Arrastra archivos aquí para cargarlos',
    'es-MX': 'Arrastra aquí los archivos para subirlos',
    'es-US': 'Arrastra los archivos aquí para cargarlos',
    'pt-PT': 'Arraste os ficheiros que pretende carregar para aqui',
    'zh-TW': '將檔案拖到此處以上傳',
    'tr-TR': 'Yüklemek için dosyaları buraya sürükleyin',
    'de-DE': 'Dateien zum Hochladen hierher ziehen',
    'nl-NL': 'Sleep bestanden hierheen om te uploaden',
    'pl-PL': 'Przeciągnij pliki tutaj, aby przesłać',
    'ta-IN': 'பதிவேற்ற இங்கே கோப்புகளை இழுக்கவும்',
    'mr-IN': 'अपलोड करण्यासाठी फाईल्स येथे ड्रॅग करा',
    'ml-IN': 'അപ്‌ലോഡ് ചെയ്യുന്നതിന് ഫയലുകൾ ഇവിടെ വലിച്ചിടുക',
    'te-IN': 'అప్‌లోడ్ చేసేందుకై ఫైళ్ళను ఇక్కడకు లాగండి',
    'kn-IN': 'ಅಪ್‌ಲೋಡ್ ಮಾಡಲು ಫೈಲ್‌ಗಳನ್ನು ಇಲ್ಲಿ ಎಳೆಯಿರಿ',
    'sv-SE': 'Dra filer hit för att ladda upp',
    'cs-CZ': 'Pro nahrání přetáhněte soubory sem',
    'it-IT': 'Trascina qui i file per caricarli',
    'pt-BR': 'Arraste os arquivos aqui para fazer upload',
    'zh-CN': '将文件拖到此处进行上传',
    'ko-KR': '업로드할 파일을 여기로 드래그하세요.',
    'ar-AE': 'اسحب الملفات هنا لتحميلها',
    'hi-IN': 'अपलोड करने के लिए फ़ाइलों को यहां ड्रैग करें',
    'bn-IN': 'আপলোড করার জন্য এখানে ফাইল টেনে আনুন',
    'he-IL': 'יש לגרור קבצים לכאן כדי להעלות',
  },
  kat_file_upload_unsuccessful: {
    'en-US': 'File upload was unsuccessful',
    'fr-FR': 'Le chargement du fichier a échoué',
    'fr-CA': 'Le téléversement de fichier a échoué',
    'ja-JP': 'ファイルのアップロードに失敗しました',
    'es-ES': 'La carga del archivo no se realizó correctamente',
    'es-MX': 'La carga de archivos no se pudo realizar',
    'es-US': 'La carga de archivos no tuvo éxito',
    'pt-PT': 'Os ficheiros não foram carregados com sucesso',
    'zh-TW': '檔案上傳失敗',
    'tr-TR': 'Dosya yükleme başarısız oldu',
    'de-DE': 'Das Hochladen der Datei war nicht erfolgreich',
    'nl-NL': 'Uploaden van bestanden is niet gelukt',
    'pl-PL': 'Przekazywanie pliku nie powiodło się',
    'ta-IN': 'கோப்பைப் பதிவேற்ற முடியவில்லை',
    'mr-IN': 'फाईल अपलोड अयशस्वी झाले',
    'ml-IN': 'ഫയൽ അപ്‌ലോഡ് ചെയ്യാനായില്ല',
    'te-IN': 'ఫైల్ అప్‌లోడ్ విజయవంతం కాలేదు',
    'kn-IN': 'ಫೈಲ್ ಅಪ್‌ಲೋಡ್ ವಿಫಲವಾಗಿದೆ',
    'sv-SE': 'Filöverföring misslyckades',
    'cs-CZ': 'Nahrání souboru bylo neúspěšné',
    'it-IT': 'Il caricamento del file non è riuscito',
    'pt-BR': 'O upload do arquivo não foi bem-sucedido',
    'zh-CN': '文件上传失败',
    'ko-KR': '파일을 업로드하지 못했습니다.',
    'ar-AE': 'لم يتم تحميل الملف بنجاح',
    'hi-IN': 'फ़ाइल अपलोड करना असफल रहा',
    'bn-IN': 'ফাইল আপলোড করা ব্যর্থ হয়েছে',
    'he-IL': 'העלאת הקובץ נכשלה',
  },
  kat_file_not_uploaded: {
    'en-US': 'File not uploaded.',
    'fr-FR': 'Fichier non chargé',
    'fr-CA': 'Fichier non téléversé',
    'ja-JP': 'ファイルがアップロードされていません',
    'es-ES': 'No se ha cargado el archivo',
    'es-MX': 'Archivo no cargado',
    'es-US': 'Archivo no cargado',
    'pt-PT': 'O ficheiro não carregou',
    'zh-TW': '檔案未上傳',
    'tr-TR': 'Dosya yüklenmedi',
    'de-DE': 'Datei nicht hochgeladen',
    'nl-NL': 'Bestand niet geüpload',
    'pl-PL': 'Plik nie został przesłany',
    'ta-IN': 'கோப்பைப் பதிவேற்ற முடியவில்லை',
    'mr-IN': 'फाईल अपलोड झाली नाही',
    'ml-IN': 'ഫയൽ അപ്‌ലോഡ് ചെയ്തിട്ടില്ല',
    'te-IN': 'ఫైల్‌ను అప్‌లోడ్ చేయలేదు',
    'kn-IN': 'ಫೈಲ್ ಅಪ್‌ಲೋಡ್ ಮಾಡಿಲ್ಲ',
    'sv-SE': 'Filen har inte laddats upp',
    'cs-CZ': 'Soubor nebyl nahrán',
    'it-IT': 'File non caricato',
    'pt-BR': 'Arquivo não carregado',
    'zh-CN': '文件未上传',
    'ko-KR': '파일이 업로드되지 않았습니다.',
    'ar-AE': 'لم يتم تحميل الملف',
    'hi-IN': 'फ़ाइल अपलोड नहीं हुई',
    'bn-IN': 'ফাইল আপলোড করা হয়নি',
    'he-IL': 'הקובץ לא הועלה',
  },
  kat_clear_all_files: {
    'en-US': 'Clear all files',
    'fr-FR': 'Effacer tous les fichiers',
    'fr-CA': 'Effacer tous les fichiers',
    'ja-JP': 'すべてのファイルをクリア',
    'es-ES': 'Borrar todos los archivos',
    'es-MX': 'Borrar todos los archivos',
    'es-US': 'Eliminar todos los archivos',
    'pt-PT': 'Eliminar todos os ficheiros',
    'zh-TW': '清空所有檔案',
    'tr-TR': 'Tüm dosyaları temizle',
    'de-DE': 'Alle Dateien löschen',
    'nl-NL': 'Alle bestanden wissen',
    'pl-PL': 'Wyczyść wszystkie pliki',
    'ta-IN': 'எல்லா கோப்புகளையும் அழி',
    'mr-IN': 'सर्व फाईल्स क्लिअर करा',
    'ml-IN': 'എല്ലാ ഫയലുകളും മായ്ക്കുക',
    'te-IN': 'అన్ని ఫైళ్ళను తొలగించు',
    'kn-IN': 'ಎಲ್ಲಾ ಫೈಲ್‌ಗಳನ್ನು ತೆರವುಗೊಳಿಸಿ',
    'sv-SE': 'Rensa alla filer',
    'cs-CZ': 'Vymazat všechny soubory',
    'it-IT': 'Cancella tutti i file',
    'pt-BR': 'Apagar todos os arquivos',
    'zh-CN': '清除所有文件',
    'ko-KR': '모든 파일 지우기',
    'ar-AE': 'مسح جميع الملفات',
    'hi-IN': 'सभी फ़ाइलें हटाएं',
    'bn-IN': 'সব ফাইল পরিষ্কার করে ফেলুন',
    'he-IL': 'ניקוי כל הקבצים',
  },
  kat_attachment_required: {
    'en-US': 'An attachment is required',
    'fr-FR': 'Une pièce jointe est requise',
    'fr-CA': 'Une pièce jointe est requise',
    'ja-JP': '添付ファイルが必要です',
    'es-ES': 'Se requiere un archivo adjunto',
    'es-MX': 'Se requiere un archivo adjunto',
    'es-US': 'Se requiere un archivo adjunto',
    'pt-PT': 'É necessário anexar um ficheiro',
    'zh-TW': '需要附件',
    'tr-TR': 'Ek gereklidir',
    'de-DE': 'Eine angehängte Datei ist erforderlich',
    'nl-NL': 'Een bijlage is vereist',
    'pl-PL': 'Wymagany jest załącznik',
    'ta-IN': 'ஓர் இணைப்பு தேவைப்படுகிறது',
    'mr-IN': 'अ‍ॅटॅचमेंट आवश्यक आहे',
    'ml-IN': 'ഒരു അറ്റാച്ച്മെന്റ് ആവശ്യമാണ്',
    'te-IN': 'జోడింపు అవసరం అవుతుంది',
    'kn-IN': 'ಒಂದು ಲಗತ್ತು ಅಗತ್ಯವಿದೆ',
    'sv-SE': 'En bilaga krävs',
    'cs-CZ': 'Je vyžadována příloha',
    'it-IT': 'È obbligatorio un allegato',
    'pt-BR': 'É necessário um anexo',
    'zh-CN': '需要附件',
    'ko-KR': '첨부 파일이 필요합니다.',
    'ar-AE': 'يجب إضافة مرفق',
    'hi-IN': 'एक अटैचमेंट ज़रूरी है',
    'bn-IN': 'একটি সংযুক্তি প্রয়োজন',
    'he-IL': 'נדרש קובץ מצורף',
  },
  kat_over_max_size: {
    'en-US': 'Attachment size is over the limit',
    'fr-FR': 'La taille des pièces jointes dépasse la limite',
    'fr-CA': 'La taille du fichier joint dépasse la limite',
    'ja-JP': '添付ファイルのサイズが上限を超えています',
    'es-ES': 'El tamaño del archivo adjunto supera el límite',
    'es-MX': 'El tamaño del archivo adjunto es superior al límite',
    'es-US': 'El tamaño del archivo adjunto supera el límite',
    'pt-PT': 'O anexo excede o limite de tamanho',
    'zh-TW': '附件大小超過限制',
    'tr-TR': 'Ek boyutu limiti aşıyor',
    'de-DE': 'Der Anhang ist zu groß',
    'nl-NL': 'De grootte van de bijlage is boven de limiet',
    'pl-PL': 'Rozmiar załącznika przekroczył limit',
    'ta-IN': 'இணைப்புக்கான அளவின் வரம்பை விடப் பெரியது',
    'mr-IN': 'अ‍ॅटॅचमेंटचा आकार मर्यादेपेक्षा जास्त आहे',
    'ml-IN': 'അറ്റാച്ച്മെന്‍റ് വലിപ്പം പരിധി കവിഞ്ഞു',
    'te-IN': 'జోడింపు సైజు పరిమితిని మించిపోయింది',
    'kn-IN': 'ಲಗತ್ತು ಗಾತ್ರವು ಮಿತಿಯನ್ನು ಮೀರಿದೆ',
    'sv-SE': 'Storlek för bifogade filer överskrider gränsen',
    'cs-CZ': 'Velikost přílohy je nad limit',
    'it-IT': "La dimensione dell'allegato supera il limite",
    'pt-BR': 'O tamanho do anexo está acima do limite',
    'zh-CN': '附件大小已超出限制',
    'ko-KR': '첨부 파일 크기가 한도를 초과했습니다.',
    'ar-AE': 'حجم المرفقات يتجاوز الحد',
    'hi-IN': 'अटैचमेंट का साइज़ सीमा से अधिक है',
    'bn-IN': 'সংযুক্তির আকার সীমাকে অতিক্রম করেছে',
    'he-IL': 'גודל הקובץ המצורף חורג מהמגבלה',
  },
  kat_unsupported_file_attached: {
    'en-US': 'Unsupported file was attached',
    'fr-FR': 'Un fichier non pris en charge a été joint',
    'fr-CA': 'Un fichier non pris en charge a été joint',
    'ja-JP': 'サポートされていないファイルが添付されました',
    'es-ES': 'Se adjuntó un archivo no compatible',
    'es-MX': 'Se adjuntó un archivo no compatible',
    'es-US': 'Se adjuntó un archivo no compatible',
    'pt-PT': 'Anexou um arquivo não suportado',
    'zh-TW': '已附加不支援的檔案',
    'tr-TR': 'Desteklenmeyen dosya eklenmiş',
    'de-DE': 'Nicht unterstützte Datei wurde angehängt',
    'nl-NL': 'Niet ondersteund bestand is bijgevoegd',
    'pl-PL': 'Został dołączony nieobsługiwany plik',
    'ta-IN': 'ஆதரிக்கப்படாத கோப்பு இணைக்கப்பட்டது',
    'mr-IN': 'असमर्थित फाईल अ‍ॅटॅच केली गेली होती',
    'ml-IN': 'പിന്തുണയ്ക്കാത്ത ഫയൽ അറ്റാച്ചുചെയ്തു',
    'te-IN': 'మద్దతు లేని ఫైల్ జోడించబడింది',
    'kn-IN': 'ಬೆಂಬಲಿಸದ ಫೈಲ್ ಅನ್ನು ಲಗತ್ತಿಸಲಾಗಿತ್ತು',
    'sv-SE': 'Bifogad fil stöds inte',
    'cs-CZ': 'Byl připojen nepodporovaný soubor',
    'it-IT': 'È stato allegato un file non supportato',
    'pt-BR': 'Um arquivo não suportado foi anexado',
    'zh-CN': '附加了不受支持的文件',
    'ko-KR': '지원되지 않는 파일이 첨부되었습니다.',
    'ar-AE': 'تم إرفاق ملف غير مدعوم',
    'hi-IN': 'अटैच की गई फ़ाइल सपोर्टेड नहीं थी',
    'bn-IN': 'অসমর্থিত ফাইল সংযুক্ত করা হয়েছিল',
    'he-IL': 'קובץ לא נתמך מצורף',
  },
  kat_title_delete_this_file: {
    'en-US': 'Delete this file?',
    'fr-FR': 'Supprimer ce fichier ?',
    'fr-CA': 'Supprimer ce fichier?',
    'ja-JP': 'このファイルを削除しますか?',
    'es-ES': '¿Eliminar este archivo?',
    'es-MX': '¿Quieres eliminar este archivo?',
    'es-US': '¿Deseas eliminar este archivo?',
    'pt-PT': 'Pretende eliminar este ficheiro?',
    'zh-TW': '要刪除這個檔案嗎？',
    'tr-TR': 'Bu dosya silinsin mi?',
    'de-DE': 'Diese Datei löschen?',
    'nl-NL': 'Dit bestand verwijderen?',
    'pl-PL': 'Usunąć ten plik?',
    'ta-IN': 'இந்தக் கோப்பை நீக்கவா?',
    'mr-IN': 'ही फाईल हटवायची?',
    'ml-IN': 'ഈ ഫയൽ ഇല്ലാതാക്കണോ?',
    'te-IN': 'ఈ ఫైల్‌ని తొలగించాలా?',
    'kn-IN': 'ಈ ಫೈಲ್ ಅಳಿಸಬೇಕೇ?',
    'sv-SE': 'Vill du ta bort den här filen?',
    'cs-CZ': 'Chcete odstranit tento soubor?',
    'it-IT': 'Eliminare questo file?',
    'pt-BR': 'Apagar este arquivo?',
    'zh-CN': '是否删除此文件？',
    'ko-KR': '이 파일을 삭제하시겠습니까?',
    'ar-AE': 'هل تريد حذف هذا الملف؟',
    'hi-IN': 'इस फ़ाइल को डिलीट करें?',
    'bn-IN': 'এই ফাইলটি ডিলিট করবেন?',
    'he-IL': 'למחוק את הקובץ הזה?',
  },
  kat_file_will_be_deleted: {
    'en-US': '{file} file will be deleted.',
    'fr-FR': 'Le fichier {file} sera supprimé.',
    'fr-CA': 'Le fichier {file} sera supprimé.',
    'ja-JP': '{file}ファイルが削除されます。',
    'es-ES': 'El archivo {file} se eliminará.',
    'es-MX': 'Se eliminará el archivo {file}.',
    'es-US': 'Se eliminará el archivo {file}.',
    'pt-PT': 'O ficheiro {file} será eliminado.',
    'zh-TW': '將刪除 {file} 檔案。',
    'tr-TR': '{file} dosyası silinecektir.',
    'de-DE': '{file} Datei wird gelöscht.',
    'nl-NL': '{file} bestand wordt verwijderd.',
    'pl-PL': 'Plik {file} zostanie usunięty.',
    'ta-IN': '{file} கோப்பு நீக்கப்படும்.',
    'mr-IN': '{file} फाईल हटवली जाईल.',
    'ml-IN': '{file} ഫയൽ ഇല്ലാതാക്കപ്പെടും.',
    'te-IN': '{file} ఫైల్ తొలగించబడుతుంది.',
    'kn-IN': '{file} ಫೈಲ್ ಅನ್ನು ಅಳಿಸಲಾಗುತ್ತದೆ.',
    'sv-SE': 'Filen {file} kommer att tas bort.',
    'cs-CZ': '{file} bude odstraněn.',
    'it-IT': 'Il file {file} verrà eliminato.',
    'pt-BR': 'O arquivo {file} será excluído.',
    'zh-CN': '{file} 文件将被删除。',
    'ko-KR': '{file} 파일이 삭제됩니다.',
    'ar-AE': 'سيتم حذف الملف {file}.',
    'hi-IN': '{file} फ़ाइल हटा दी जाएगी.',
    'bn-IN': '{file} ফাইল ডিলিট হয়ে যাবে।',
    'he-IL': 'קובץ {file} יימחק.',
  },
  kat_title_delete_all_files: {
    'en-US': 'Delete all files?',
    'fr-FR': 'Supprimer tous les fichiers ?',
    'fr-CA': 'Supprimer tous les fichiers?',
    'ja-JP': 'すべてのファイルを削除しますか?',
    'es-ES': '¿Eliminar todos los archivos?',
    'es-MX': '¿Quieres eliminar todos los archivos?',
    'es-US': '¿Deseas eliminar todos los archivos?',
    'pt-PT': 'Pretende eliminar todos os ficheiros?',
    'zh-TW': '要刪除所有檔案嗎？',
    'tr-TR': 'Tüm dosyalar silinsin mi?',
    'de-DE': 'Alle Dateien löschen?',
    'nl-NL': 'Alle bestanden verwijderen?',
    'pl-PL': 'Usunąć wszystkie pliki?',
    'ta-IN': 'எல்லாக் கோப்புகளையும் நீக்கவா?',
    'mr-IN': 'सर्व फाईल्स हटवायच्या?',
    'ml-IN': 'എല്ലാ ഫയലുകളും ഇല്ലാതാക്കണോ?',
    'te-IN': 'అన్ని ఫైళ్ళను తొలగించాలా?',
    'kn-IN': 'ಎಲ್ಲಾ ಫೈಲ್‌ಗಳನ್ನು ಅಳಿಸಬೇಕೇ?',
    'sv-SE': 'Ta bort alla filer?',
    'cs-CZ': 'Smazat všechny soubory?',
    'it-IT': 'Eliminare tutti i file?',
    'pt-BR': 'Excluir todos os arquivos?',
    'zh-CN': '是否删除所有文件？',
    'ko-KR': '모든 파일을 삭제하시겠습니까?',
    'ar-AE': 'هل تريد حذف جميع الملفات؟',
    'hi-IN': 'सभी फ़ाइलें डिलीट करें?',
    'bn-IN': 'সব ফাইল ডিলিট করবেন?',
    'he-IL': 'למחוק את כל הקבצים?',
  },
  kat_files_will_be_deleted: {
    'en-US': 'All files will be deleted.',
    'fr-FR': 'Tous les fichiers seront supprimés.',
    'fr-CA': 'Tous les fichiers seront supprimés.',
    'ja-JP': 'すべてのファイルが削除されます。',
    'es-ES': 'Se eliminarán todos los archivos.',
    'es-MX': 'Todos los archivos serán eliminados.',
    'es-US': 'Se eliminarán todos los archivos.',
    'pt-PT': 'Todos os ficheiros serão eliminados.',
    'zh-TW': '所有檔案都將刪除。',
    'tr-TR': 'Tüm dosyalar silinecek.',
    'de-DE': 'Alle Dateien werden gelöscht.',
    'nl-NL': 'Alle bestanden worden verwijderd.',
    'pl-PL': 'Wszystkie pliki zostaną usunięte.',
    'ta-IN': 'அனைத்துக் கோப்புகளும் நீக்கப்படும்.',
    'mr-IN': 'सर्व फाईल्स हटवल्या जातील.',
    'ml-IN': 'എല്ലാ ഫയലുകളും ഇല്ലാതാക്കപ്പെടും.',
    'te-IN': 'అన్ని ఫైళ్లు తొలగించబడతాయి.',
    'kn-IN': 'ಎಲ್ಲಾ ಫೈಲ್‌ಗಳನ್ನು ಅಳಿಸಲಾಗುತ್ತದೆ.',
    'sv-SE': 'Alla filer kommer att raderas.',
    'cs-CZ': 'Všechny soubory budou smazány.',
    'it-IT': 'Tutti i file verranno eliminati.',
    'pt-BR': 'Todos os arquivos serão excluídos.',
    'zh-CN': '所有文件都将被删除。',
    'ko-KR': '모든 파일이 삭제됩니다.',
    'ar-AE': 'سيتم حذف جميع الملفات.',
    'hi-IN': 'सभी फाइलें डिलीट कर दी जाएंगी.',
    'bn-IN': 'সমস্ত ফাইল ডিলিট হয়ে যাবে।',
    'he-IL': 'כל הקבצים יימחקו.',
  },
  kat_title_replace_this_file: {
    'en-US': 'Replace this file?',
    'fr-FR': 'Remplacer ce fichier ?',
    'fr-CA': 'Remplacer ce fichier?',
    'ja-JP': 'このファイルを置き換えますか?',
    'es-ES': '¿Reemplazar este archivo?',
    'es-MX': '¿Quieres reemplazar este archivo?',
    'es-US': '¿Deseas reemplazar este archivo?',
    'pt-PT': 'Pretende substituir este ficheiro?',
    'zh-TW': '要取代這個檔案嗎？',
    'tr-TR': 'Bu dosya değiştirilsin mi?',
    'de-DE': 'Diese Datei ersetzen?',
    'nl-NL': 'Dit bestand vervangen?',
    'pl-PL': 'Zastąpić ten plik?',
    'ta-IN': 'இந்தக் கோப்பை மாற்றியமைக்கவா?',
    'mr-IN': 'ही फाईल बदली करायची?',
    'ml-IN': 'ഈ ഫയൽ റീപ്ലേസ് ചെയ്യണോ?',
    'te-IN': 'ఈ ఫైల్‌ని రీప్లేస్ చేయాలా?',
    'kn-IN': 'ಈ ಫೈಲ್ ಬದಲಾಯಿಸಬೇಕೇ?',
    'sv-SE': 'Vill du ersätta den här filen?',
    'cs-CZ': 'Chcete nahradit tento soubor?',
    'it-IT': 'Sostituire questo file?',
    'pt-BR': 'Substituir este arquivo?',
    'zh-CN': '是否替换此文件？',
    'ko-KR': '이 파일을 바꾸시겠습니까?',
    'ar-AE': 'هل تريد استبدال هذا الملف؟',
    'hi-IN': 'इस फ़ाइल को बदलें?',
    'bn-IN': 'এই ফাইলটি প্রতিস্থাপন করবেন?',
    'he-IL': 'להחליף את הקובץ הזה?',
  },
  kat_file_will_be_replaced: {
    'en-US': '{file} will be replaced with a new file.',
    'fr-FR': 'Le fichier {file} sera remplacé par un nouveau fichier.',
    'fr-CA': '{file} sera remplacé par un nouveau fichier.',
    'ja-JP': '{file}が新しいファイルに置き換えられます。',
    'es-ES': '{file} se sustituirá por un archivo nuevo.',
    'es-MX': '{file} se reemplazará por un nuevo archivo.',
    'es-US': 'Se reemplazará {file} por un nuevo archivo.',
    'pt-PT': '{file} será substituído por um novo ficheiro.',
    'zh-TW': '{file} 將替換成新檔案。',
    'tr-TR': '{file} yeni bir dosya ile değiştirilecektir.',
    'de-DE': '{file} wird durch eine neue Datei ersetzt.',
    'nl-NL': '{file} wordt vervangen door een nieuw bestand.',
    'pl-PL': '{file} zostanie zastąpiony nowym plikiem.',
    'ta-IN': '{file} புதிய கோப்பாக மாற்றியமைக்கப்படும்.',
    'mr-IN': '{file} नवीन फाईलने बदली केली जाईल.',
    'ml-IN': '{file} ഒരു പുതിയ ഫയൽ ഉപയോഗിച്ച് റീപ്ലേസ് ചെയ്യും.',
    'te-IN': '{file}ను కొత్త ఫైల్ రీప్లేస్ చేస్తుంది.',
    'kn-IN': '{file} ಅನ್ನು ಹೊಸ ಫೈಲ್‌ನೊಂದಿಗೆ ಬದಲಾಯಿಸಲಾಗುತ್ತದೆ.',
    'sv-SE': '{file} kommer att ersättas med en ny fil.',
    'cs-CZ': '{file} bude nahrazen novým souborem.',
    'it-IT': '{file} verrà sostituito con un nuovo file.',
    'pt-BR': '{file} será substituído por um novo arquivo.',
    'zh-CN': '{file} 将替换为新文件。',
    'ko-KR': '{file}이(가) 새 파일로 변경됩니다.',
    'ar-AE': 'سيتم استبدال {file} بملف جديد.',
    'hi-IN': '{file} को एक नई फ़ाइल के साथ बदल दिया जाएगा.',
    'bn-IN': 'একটি নতুন ফাইল দিয়ে {file} প্রতিস্থাপিত করা হবে।',
    'he-IL': '{file} יוחלף בקובץ חדש.',
  },
  kat_title_replace_all_files: {
    'en-US': 'Replace {number} files?',
    'fr-FR': 'Remplacer {number} fichiers?',
    'fr-CA': 'Remplacer {number} fichiers?',
    'ja-JP': '{number}ファイルを置き換えますか?',
    'es-ES': '¿Reemplazar {number} archivos?',
    'es-MX': '¿Quieres reemplazar {number} archivos?',
    'es-US': '¿Deseas reemplazar {number} archivos?',
    'pt-PT': 'Substituir {number} ficheiros?',
    'zh-TW': '要替換 {number} 支檔案嗎？',
    'tr-TR': '{number} dosya değiştirilsin mi?',
    'de-DE': '{number} Dateien ersetzen?',
    'nl-NL': '{number} bestanden vervangen?',
    'pl-PL': 'Zastąpić następującą liczbę plików: {number}?',
    'ta-IN': '{number} கோப்புகளை மாற்றியமைக்கவா?',
    'mr-IN': '{number} फाईल्स बदली करायच्या?',
    'ml-IN': '{number} ഫയലുകൾ റീപ്ലേസ് ചെയ്യണോ?',
    'te-IN': '{number} ఫైళ్ళను రీప్లేస్ చేయమంటారా?',
    'kn-IN': '{number} ಫೈಲ್‌ಗಳನ್ನು ಬದಲಾಯಿಸಬೇಕೇ?',
    'sv-SE': 'Ersätt {number} filer?',
    'cs-CZ': 'Nahradit {number} soubory?',
    'it-IT': 'Sostituire {number} file?',
    'pt-BR': 'Substituir {number} arquivos?',
    'zh-CN': '是否替换 {number} 文件？',
    'ko-KR': '{number} 파일을 바꾸시겠습니까?',
    'ar-AE': 'هل تريد استبدال {number} ملفات؟',
    'hi-IN': 'फ़ाइलों {number} को बदलें?',
    'bn-IN': '{number} ফাইল প্রতিস্থাপন করবেন?',
    'he-IL': 'האם להחליף {number} קבצים?',
  },
  kat_files_will_be_replaced: {
    'en-US': '{file} will be replaced with new files.',
    'fr-FR': 'Les fichiers {file} seront remplacés par de nouveaux fichiers.',
    'fr-CA': '{file} sera remplacé par de nouveaux fichiers.',
    'ja-JP': '{file}が新しいファイルに置き換えられます。',
    'es-ES': '{file} se sustituirán por archivos nuevos.',
    'es-MX': '{file} se reemplazará por nuevos archivos.',
    'es-US': 'Se reemplazará {file} por nuevos archivos.',
    'pt-PT': '{file} serão substituídos por novos ficheiros.',
    'zh-TW': '{file} 將替換成新檔案。',
    'tr-TR': '{file} yeni dosyalarla değiştirilecektir.',
    'de-DE': '{file} wird durch neue Dateien ersetzt.',
    'nl-NL': '{file} wordt vervangen door nieuwe bestanden.',
    'pl-PL': '{file} zostaną zastąpione nowymi plikami.',
    'ta-IN': '{file} புதிய கோப்புகளாக மாற்றியமைக்கப்படும்.',
    'mr-IN': '{file} नवीन फाईल्सनी बदली केल्या जातील.',
    'ml-IN': '{file} പുതിയ ഫയലുകൾ ഉപയോഗിച്ച് റീപ്ലേസ് ചെയ്യും.',
    'te-IN': '{file}ను కొత్త ఫైళ్ళు రీప్లేస్ చేస్తాయి.',
    'kn-IN': '{file} ಅನ್ನು ಹೊಸ ಫೈಲ್‌ಗಳೊಂದಿಗೆ ಬದಲಾಯಿಸಲಾಗುತ್ತದೆ.',
    'sv-SE': '{file} kommer att ersättas med nya filer.',
    'cs-CZ': '{file} budou nahrazeny novými soubory.',
    'it-IT': '{file} verrà sostituito con nuovi file.',
    'pt-BR': '{file} será substituído por novos arquivos.',
    'zh-CN': '{file} 将替换为新文件。',
    'ko-KR': '{file}이(가) 새 파일로 변경됩니다.',
    'ar-AE': 'سيتم استبدال {file} بملفات جديدة.',
    'hi-IN': '{file} को नई फ़ाइलों के साथ बदल दिया जाएगा.',
    'bn-IN': 'নতুন ফাইল দিয়ে {file} প্রতিস্থাপিত করা হবে।',
    'he-IL': '{file} יוחלפו בקבצים חדשים.',
  },
  kat_label_cancel: {
    'en-US': 'Cancel',
    'fr-FR': 'Annuler',
    'fr-CA': 'Annuler',
    'ja-JP': 'キャンセル',
    'es-ES': 'Cancelar',
    'es-MX': 'Cancelar',
    'es-US': 'Cancelar',
    'pt-PT': 'Cancelar',
    'zh-TW': '取消',
    'tr-TR': 'İptal',
    'de-DE': 'Abbrechen',
    'nl-NL': 'Annuleren',
    'pl-PL': 'Anuluj',
    'ta-IN': 'ரத்துசெய்',
    'mr-IN': 'रद्द करा',
    'ml-IN': 'റദ്ദാക്കുക',
    'te-IN': 'రద్దు చేయి',
    'kn-IN': 'ರದ್ದುಮಾಡಿ',
    'sv-SE': 'Avbryt',
    'cs-CZ': 'Zrušit',
    'it-IT': 'Annulla',
    'pt-BR': 'Cancelar',
    'zh-CN': '取消',
    'ko-KR': '취소',
    'ar-AE': 'إلغاء',
    'hi-IN': 'कैंसल करें',
    'bn-IN': 'বাতিল করুন',
    'he-IL': 'ביטול',
  },
  kat_label_delete: {
    'en-US': 'Delete',
    'fr-FR': 'Supprimer',
    'fr-CA': 'Supprimer',
    'ja-JP': '削除',
    'es-ES': 'Eliminar',
    'es-MX': 'Eliminar',
    'es-US': 'Eliminar',
    'pt-PT': 'Eliminar',
    'zh-TW': '刪除',
    'tr-TR': 'Sil',
    'de-DE': 'Löschen',
    'nl-NL': 'Verwijderen',
    'pl-PL': 'Usuń',
    'ta-IN': 'நீக்கு',
    'mr-IN': 'हटवा',
    'ml-IN': 'ഇല്ലാതാക്കുക',
    'te-IN': 'తొలగించు',
    'kn-IN': 'ಅಳಿಸಿ',
    'sv-SE': 'Ta bort',
    'cs-CZ': 'Odstranit',
    'it-IT': 'Elimina',
    'pt-BR': 'Excluir',
    'zh-CN': '删除',
    'ko-KR': '삭제',
    'ar-AE': 'حذف',
    'hi-IN': 'डिलीट करें',
    'bn-IN': 'ডিলিট করুন',
    'he-IL': 'מחיקה',
  },
  kat_label_replace: {
    'en-US': 'Replace',
    'fr-FR': 'Remplacer',
    'fr-CA': 'Remplacer',
    'ja-JP': '置き換え',
    'es-ES': 'Reemplazar',
    'es-MX': 'Reemplazar',
    'es-US': 'Reemplazar',
    'pt-PT': 'Substituir',
    'zh-TW': '取代',
    'tr-TR': 'Değiştir',
    'de-DE': 'Ersetzen',
    'nl-NL': 'Vervangen',
    'pl-PL': 'Zastąp',
    'ta-IN': 'மாற்று',
    'mr-IN': 'बदली करा',
    'ml-IN': 'റീപ്ലേസ് ചെയ്യുക',
    'te-IN': 'రీప్లేస్ చేయండి',
    'kn-IN': 'ಬದಲಾಯಿಸಿ',
    'sv-SE': 'Ersätt',
    'cs-CZ': 'Nahradit',
    'it-IT': 'Sostituisci',
    'pt-BR': 'Substituir',
    'zh-CN': '替换',
    'ko-KR': '변경',
    'ar-AE': 'استبدال',
    'hi-IN': 'बदलें',
    'bn-IN': 'প্রতিস্থাপন করুন',
    'he-IL': 'החלפה',
  },
};

export default katTranslator(strings);
